import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getAccommodationByPersonIdAsync } from "@application/features/accommodation/accommodationThunk";
import { useAppDispatch, useAppSelector } from "@application/store/useStore";
import { alpha, Box, Typography } from "@mui/material";
import { SteperHeader } from "@ui/components/Header/SteperHeader";
import { HSwitchGroup } from "@ui/components/inputs/HSwitchGroup";
import { useEffect, useMemo } from "react";
import { useWatch } from "react-hook-form";
import Grid from "@mui/material/Grid2";
import { HTabInput } from "@ui/components/inputs/HTabInput";
import { useTranslation } from "react-i18next";
import { formatLocalizedDate } from "@infrastructure/helpers";
import i18n from "../../../../i18n";
export const Accommodation = ({ control, errors, personId, setValue, eventType, onAccommodationChange, formMod = "edit", }) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { invitationDatesForAccommodation, invitationDates } = useAppSelector((state) => state.invitation);
    const { accommodationInfo } = useAppSelector((state) => state.accommodation);
    const { linkVerification } = useAppSelector((state) => state.event);
    const { personalInfo } = useAppSelector((state) => state.person);
    const isRegistered = personalInfo?.invitationStatus === 3;
    const dateOptions = useMemo(() => {
        if (!invitationDatesForAccommodation)
            return [];
        return invitationDatesForAccommodation.map((date) => ({
            label: formatLocalizedDate(date.invitedDate, i18n.language),
            value: date.id,
        }));
    }, [invitationDatesForAccommodation, i18n.language]);
    const overNightStay = useWatch({
        control,
        name: "Accommodation.OverNightStay",
        defaultValue: undefined,
    });
    useEffect(() => {
        if (overNightStay === "false") {
            setValue("Accommodation.AccommodationDates", []);
        }
    }, [overNightStay, setValue]);
    // useEffect(() => {
    //   if (linkVerification?.data?.invitationId) {
    //     debugger;
    //     dispatch(
    //       getInvitationDatesForByInvitationIdWithPreAccDateAsync(
    //         linkVerification?.data?.invitationId
    //       )
    //     );
    //   }
    // }, [dispatch, linkVerification?.data?.invitationId]);
    // useEffect(() => {
    //   dispatch(getAccommodationByPersonIdAsync(personId))
    //     .unwrap()
    //     .then((response) => {
    //       if (response) {
    //       }
    //     });
    // }, [personId]);
    useEffect(() => {
        if (!personId)
            return;
        dispatch(getAccommodationByPersonIdAsync(personId))
            .unwrap()
            .then((response) => {
            if (response) {
                onAccommodationChange(response.id);
                setValue("Accommodation.OverNightStay", response.id ? String(response.stayOverNight) : undefined);
                const selectedDates = dateOptions
                    .filter((option) => response.accommodationDates?.some((dateObj) => dateObj.id === option.value))
                    .map((option) => option.value);
                setValue("Accommodation.AccommodationDates", selectedDates);
            }
        });
    }, [personId, dispatch, setValue]);
    // useEffect(() => {
    //   if (linkVerification?.data?.invitationId)
    //     dispatch(
    //       getInvitationDatesForByInvitationIdWithPreAccDateAsync(
    //         linkVerification?.data?.invitationId
    //       )
    //     )
    //       .unwrap()
    //       .then((response) => {
    //         console.log(
    //           "response.accommodationDates",
    //           response.accommodationDates
    //         );
    //       });
    // }, [invitationDatesForAccommodation, linkVerification?.data?.invitationId]);
    return (_jsxs("div", { children: [_jsx(SteperHeader, { title: t("event.accomodationInformation") }), _jsxs(Grid, { container: true, spacing: 2, mt: 2, children: [_jsx(Grid, { size: 12, children: _jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [_jsx(Typography, { variant: "body1", color: "#00244D", children: t("event.accomodationInfoText") }), _jsx(Typography, { variant: "subtitle1", color: "#00244D", children: t("event.accomodationImportantNote") })] }) }), _jsx(Grid, { size: 12, children: _jsx(Box, { sx: {
                                display: "flex",
                                flexDirection: "column",
                                borderRadius: 1,
                                border: (theme) => `1px solid ${alpha(theme.palette.edark.main, 0.2)}`,
                                borderColor: (theme) => errors?.Accommodation?.OverNightStay?.message
                                    ? theme.palette.error.main
                                    : alpha(theme.palette.edark.main, 0.2),
                                backgroundColor: (theme) => alpha(theme.palette.edark.main, 0.04),
                                py: 2,
                                px: 2.5,
                                gap: 0.5,
                            }, children: _jsxs(Grid, { container: true, spacing: 1, children: [_jsx(Grid, { size: 12, children: _jsx(HTabInput, { control: control, error: errors?.Accommodation?.OverNightStay?.message, options: [
                                                { label: t("actions.yes"), value: "true" },
                                                { label: t("actions.no"), value: "false" },
                                            ], name: "Accommodation.OverNightStay", label: t("formFields.wantToStayOvernight"), disabled: formMod === "view", rules: {
                                                required: {
                                                    value: true,
                                                    message: "validations.chooseOption",
                                                },
                                                validate: (value) => value?.length > 0 ||
                                                    "validations.attendanceDatesRequired",
                                            } }) }), _jsx(Grid, { size: 12, children: overNightStay !== undefined && overNightStay === "true" && (_jsx(HSwitchGroup, { label: t("formFields.whichOvernightStayDates"), options: dateOptions, control: control, name: "Accommodation.AccommodationDates", rules: { required: "validations.chooseDateOption" }, error: errors?.Accommodation?.AccommodationDates?.message, disabled: formMod === "view" })) })] }) }) })] })] }));
};
